import { Button, Stack } from 'react-bootstrap';
import { ReactComponent as UploadIcon } from 'assets/images/upload.svg';
import { ReactComponent as EditIcon } from 'assets/images/edit.svg';
import { ReactComponent as DeleteIcon } from 'assets/images/delete.svg';
import { Tooltip } from '@mui/material';

interface ChecklistActionsProps {
  hideUploadBtn: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
  onUpload?: () => void;
}

const ChecklistActions = ({
  hideUploadBtn,
  onUpload,
  onEdit,
  onDelete,
}: ChecklistActionsProps) => {
  return (
    <Stack direction="horizontal">
      {!hideUploadBtn && (
        <Button
          variant="link"
          size="sm"
          className="text-muted p-1"
          onClick={onUpload}
        >
          <Tooltip title="Upload" placement="top" arrow>
            <UploadIcon width="20" />
          </Tooltip>
        </Button>
      )}
      <Button
        variant="link"
        size="sm"
        className="text-muted p-1"
        onClick={onEdit}
      >
        <Tooltip title="Edit" placement="top" arrow>
          <EditIcon width="20" />
        </Tooltip>
      </Button>
      <Button
        variant="link"
        size="sm"
        className="text-muted p-1"
        onClick={onDelete}
      >
        <Tooltip title="Delete" placement="top" arrow>
          <DeleteIcon width="20" />
        </Tooltip>
      </Button>
    </Stack>
  );
};

export default ChecklistActions;

ChecklistActions.defaultProps = {
  hideUploadBtn: false,
};
